import { NgTemplateOutlet } from '@angular/common';
import { Component, input, ChangeDetectionStrategy } from '@angular/core';

import { InfoboxComponent } from '@core/components-infobox-legacy';
import { CandidateSkillsChartComponent } from '@core/evaluations-ui';
import { TranslatePipe } from '@core/i18n-legacy';
import {
  JobSkillsSummaryDetailsBasicInfo,
  SkillDetailsStatus,
} from '@core/positions-and-skills-types';
import { Theme } from '@core/theme-util';
import { BadgeComponent, IconComponent, RtTooltip } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-job-skills-summary-details-chart-section',
  templateUrl: './job-skills-summary-details-chart-section.component.html',
  styleUrls: ['./job-skills-summary-details-chart-section.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    TranslatePipe,
    BadgeComponent,
    CandidateSkillsChartComponent,
    InfoboxComponent,
    IconComponent,
    NgTemplateOutlet,
    RtTooltip,
  ],
})
export class JobSkillsSummaryDetailsChartSectionComponent {
  protected readonly SkillDetailsStatus = SkillDetailsStatus;

  public readonly summaryBasicInfo = input.required<JobSkillsSummaryDetailsBasicInfo>();
  public readonly isHidden = input.required<boolean>();
  public readonly theme = input.required<Theme>();
}
